import type React from 'react';
import styled from 'styled-components';
import { Locale } from '@enmon/commons';
import { FormattedMessage } from '@/components/formatted_message/FormattedMessage';
import { Select } from '@/components/form';
import { LanguageMenu as messages } from './messages';
import { LOCALE_TRANSLATED } from '@/common/messages/locale';
import { useUpdateMe } from '@/services/hooks/users/useUpdateMe';
import { useActiveUser } from '@/containers/App';
import { useLocaleState } from '@/containers/LanguageProvider/hooks/useLocaleState';

const StyledSelect = styled(Select<Locale>)`
  && {
    background-color: transparent;
    border: none !important;
    box-shadow: none !important;

    .ant-select-content,
    .ant-select-selection-item {
      color: ${({ theme }) => theme.color.grey.white} !important;
      padding-right: 0 !important;
    }

    .ant-select-suffix {
      display: none;
    }
  }
`;

export const LanguageMenu: React.FC = () => {
  const { locale, setLocale } = useLocaleState();
  const { mutate: changeUserLocale } = useUpdateMe();
  // useActiveUser used to avoid the "User not found" error
  const user = useActiveUser();

  const onToggleSelect = (newLocale: Locale) => {
    if (newLocale) {
      setLocale(newLocale);
      if (user) {
        changeUserLocale({ locale: newLocale });
      }
    }
  };

  const options = [
    {
      label: <FormattedMessage {...messages.title} />,
      options: Object.values(Locale).map(loc => ({
        value: loc,
        label: <FormattedMessage {...LOCALE_TRANSLATED[loc]} />,
        'data-cy': `${loc}-option`,
        'data-test': `${loc}-option`,
      })),
    },
  ];

  return (
    <StyledSelect
      value={locale}
      onChange={onToggleSelect}
      variant="borderless"
      options={options}
      data-cy="language-menu"
      data-test="language-menu"
      popupMatchSelectWidth={false}
    />
  );
};
